export default {
  date: 'Fecha',
  chooseExpDate: 'Elige una fecha',
  filterExpDate: 'Filtrar por fecha',
  experienceType: 'Tipo',
  filterExperienceType: 'Filtrar por tipo',
  experienceVibe: 'Vibe',
  filterExperienceVibe: 'Filtrar por vibe',
  search: 'Buscar',
  viewCalendar: 'Ver Calendario Completo',
  back: 'Atrás',
  previous: 'Anterior',
  next: 'Siguiente',
  noExperiences: 'Sin Experiencias',
  selectDate: 'Seleccionar fecha',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  submit: 'Enviar',
  filterExperienceTypeScreenReader:
    'Use estos filtros para restringir los resultados. El contenido se actualiza automáticamente cuando se selecciona un filtro.',
};
